import React,{ Fragment, useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, Col, Container, Form, FormGroup, Nav, Row } from "reactstrap";
import * as yup from "yup";
import Breadcrumb from "../../../../layout/breadcrumb";
import ModalFormSubmit from "../../../../share-components/form/modalFormSubmit";
import CommonDataTable from "../../../../share-components/table/commonDataTable";
import PreLoader from "../../../../share-components/ui/preLoader";
import withReducer from "../../../../store/withReducer";
import { partnerSettingsResponseToTable } from "../../../../utils/mapper";
import partnerReducer from "../../store";
import OrderConditionForm from "./orderConditionsForm";
import { addPartnerOrderConditions, addShippingRules, closeEditDialog, deletePartnerOrderConditions, getAllPartnerOrderConditions, openEditDialog, openNewDialog, selectPartnerOrderConditions, updatePartnerOrderConditions } from "../../store/partnerOrderConditionsSlice";


const defaultValues = {
  id: "",
  name: "",
  // hs_code: "",
  publish_at: "",
};

const schema = yup.object().shape({
  name: yup.string().required("You must enter a product type name"),
  // hsCOde: yup.string().required('You must enter a HS Code'),
});

function OrderConditions() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState([]);
  const [hsCode, setHsCode] = useState([]);
  const currentUser = useSelector(({ authReducer }) => authReducer.data.user);
  const orderConditions = useSelector(selectPartnerOrderConditions);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);

  const { handleSubmit, formState, reset, control, register, setValue, handleChange, trigger, getValues } = useForm({
    mode: "onChange",
    defaultValues,
    resolver: yupResolver(schema),
  });

  const { errors } = formState;

  useEffect(() => {
    getData();
  }, [dispatch, name, hsCode]);

  const getData = () => {
    const data = {
      name,
      hsCode,
    };
    setTableLoading(true);
    dispatch(getAllPartnerOrderConditions({ ...data })).then((res) => {
      setTableLoading(false);
    });
  };

  let btnText = "";
  let publishValue = 0;
  let saveValue = 0;
  if (getValues) {
    if (getValues("publish_at") == 1) {
      btnText = "Save & Unpublish";
      publishValue = 0;
      saveValue = 1;
    } else {
      btnText = "Save & Publish";
      publishValue = 1;
      saveValue = 0;
    }
  }

  const dataMenu = [
    {
      type: 0,
      text: "Partner",
    },
    {
      type: 1,
      text: "Shipping Rules",
    },
  ];

  const tableColumns = [
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      left: true,
    },
    // {
    //   name: "HS Code",
    //   selector: (row) => row.hsCode,
    //   sortable: true,
    //   left: true,
    // },
  ];

  const closeDialog = () => {
    dispatch(closeEditDialog());
  };

  const onEdit = (row) => {
    dispatch(openEditDialog(row));
  };

  const onDelete = (row) => {
    dispatch(deletePartnerOrderConditions(row.id)).then((res) => getData());
  };

  const onSubmitForm = (dialog, data) => {
    setButtonDisable(true);

    if (dialog.type === "new") {
      dispatch(addPartnerOrderConditions({ ...data })).then((res) => {
        setButtonDisable(false);
        getData();
        console.log(res);
        if (!res.error) closeDialog(dialog.type);
      });
    } else {
      dispatch(updatePartnerOrderConditions({ ...data })).then((res) => {
        setButtonDisable(false);
        getData();
        if (!res.error) closeDialog(dialog.type);
      });
    }
  };

  return (
    <Fragment>
      <Container fluid={true} className="product-wrapper">
        {loading ? (
          <PreLoader />
        ) : (
          <>
            <Breadcrumb data={dataMenu} title="Order Conditions" />
            <div className="product-grid">
              <div className="feature-products">
                <Row>
                  <Col sm="12">
                    {currentUser.permission.includes("Create Order Condition") ? (
                      <Card>
                        <Row>
                          <Col sm="6">
                            <Nav tabs className="border-tab"></Nav>
                          </Col>
                          <Col sm="6">
                            <div className="float-sm-right p-3">
                              <a
                                className="btn btn-sm btn-primary"
                                onClick={() => {
                                  dispatch(openNewDialog());
                                }}
                              >
                                {" "}
                                <i className="fa fa-plus"></i> Add Order Condition
                              </a>
                            </div>
                          </Col>
                        </Row>
                      </Card>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <Form>
                      <FormGroup className="m-0">
                        <input
                          onChange={(e) => {
                            setName(e.target.value);
                          }}
                          type="text"
                          className="form-control border"
                          placeholder="Search By Order Condition Name"
                        />
                        <i className="fa fa-search"></i>
                      </FormGroup>
                    </Form>
                  </Col>
                  {/* <Col sm="6">
                    <Form>
                      <FormGroup className="m-0">
                        <input
                          onChange={(e) => setHsCode(e.target.value)}
                          type="text"
                          className="form-control border"
                          placeholder="Search By HS Code"
                        />
                        <i className="fa fa-search"></i>
                      </FormGroup>
                    </Form>
                  </Col> */}
                </Row>
              </div>
            </div>

            <Row>
              <Col sm="12">
                <Card>
                  <CardBody>
                    {tableLoading ? (
                      <div style={{ minHeight: 400 }}>
                        <PreLoader />
                      </div>
                    ) : (
                      <div className="table-responsive product-table mt-4">
                        <CommonDataTable
                          headerColumns={tableColumns}
                          gridData={partnerSettingsResponseToTable(orderConditions)}
                          pagination
                          onEdit={currentUser.permission.includes("Update Order Condition") ? onEdit : ""}
                          onDelete={currentUser.permission.includes("Delete Order Condition") ? onDelete : ""}
                        />
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </>
        )}
      </Container>

      <ModalFormSubmit
        defaultValues={defaultValues}
        schema={schema}
        onSubmitForm={onSubmitForm}
        reset={reset}
        formState={formState}
        handleSubmit={handleSubmit}
        title="Order Conditions"
        selector="partner"
        dialog={({ partner }) => partner.partnerOrderConditions.addDialog}
        closeDialog={closeDialog}
        publish
        setValue={setValue}
        getValues={getValues}
        btnText={btnText}
        publishValue={publishValue}
        saveValue={saveValue}
        buttonDisable={buttonDisable}
      >
        <OrderConditionForm control={control} errors={errors} register={register} setValue={setValue} trigger={trigger} getValues={getValues} />
      </ModalFormSubmit>
    </Fragment>
  );
}

export default withReducer([{ partnerOrderConditions: partnerReducer }])(OrderConditions);
